import React from 'react';
import PropTypes from 'prop-types';
import CustomAmountInput from '../containers/CustomAmountInput';
import CashButton from '../../cashPay/CashButton';
import Modal from '../../Modal';

const RefundModal = ({
  title,
  close,
  maxRefund,
  refundCustom,
  disabled,
  canCustomRefund,
  customAmountIsOn,
  customAmountOn,
  hasTip,
  refundTip,
  maxRefundAmount,
  totalAmount,
  currency,
}) => (
  <Modal title={title} close={close} showCloseButton>
    <div className="u-ph++ u-pv+">
      <div className="layout layout--small layout--center u-mb" display-if={canCustomRefund}>
        <div className="layout__item u-1/5" display-if={totalAmount > 0}>
          <CashButton
            onClick={maxRefund}
            disabled={disabled || customAmountIsOn}
            automationId="button:refund:full"
          >
            Full
          </CashButton>
        </div>
        <div className="layout__item u-1/5" display-if={hasTip}>
          <CashButton
            onClick={refundTip}
            disabled={disabled || customAmountIsOn}
            automationId="button:refund:tip"
          >
            Tip
          </CashButton>
        </div>
        <div className="layout__item u-1/5" display-if={totalAmount > 0}>
          <CashButton
            onClick={customAmountOn}
            active={customAmountIsOn}
            disabled={disabled}
            automationId="button:refund:custom"
          >
            Custom
          </CashButton>
        </div>
      </div>
      <CustomAmountInput
        display-if={customAmountIsOn || !canCustomRefund}
        defaultValue={canCustomRefund ? 0 : maxRefundAmount}
        onSubmit={refundCustom}
        readOnly={!canCustomRefund}
        max={totalAmount}
        disabled={disabled}
        currency={currency}
      />
    </div>
  </Modal>
);
RefundModal.propTypes = {
  title: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  maxRefund: PropTypes.func.isRequired,
  refundCustom: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  canCustomRefund: PropTypes.bool,
  customAmountIsOn: PropTypes.bool.isRequired,
  customAmountOn: PropTypes.func.isRequired,
  hasTip: PropTypes.bool.isRequired,
  refundTip: PropTypes.func.isRequired,
  maxRefundAmount: PropTypes.number.isRequired,
  totalAmount: PropTypes.number.isRequired,
  currency: PropTypes.string,
};
RefundModal.defaultProps = {
  disabled: false,
  canCustomRefund: false,
  currency: 'usd',
};

export default RefundModal;
